require("./src/fonts/fonts.css");

const React = require("react");
const { GoogleReCaptchaProvider } = require("react-google-recaptcha-v3");
const GlobalContextProvider =
  require("./src/context/GlobalContextProvider").default;

function scrollToAnchorIfPresent(hash) {
  if (!hash) return;
  const targetId = decodeURIComponent(hash.replace("#", ""));
  if (!targetId) return;

  let attemptsRemaining = 12;

  const tryScroll = () => {
    const targetElement =
      document.getElementById(targetId) ||
      document.querySelector(`[name="${targetId}"]`);

    if (targetElement) {
      // Smoothly scroll to the element; adjust here if you need header offset
      targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
      return;
    }

    if (attemptsRemaining > 0) {
      attemptsRemaining -= 1;
      setTimeout(tryScroll, 100);
    }
  };

  // Defer to allow React tree to render/mount
  setTimeout(tryScroll, 0);
}

exports.wrapRootElement = ({ element }) => {
  return (
    <GlobalContextProvider>
      <GoogleReCaptchaProvider
        reCaptchaKey={`${process.env.GATSBY_RECAPTCHA_SITE_KEY}`}
      >
        {element}
      </GoogleReCaptchaProvider>
    </GlobalContextProvider>
  );
};

exports.shouldUpdateScroll = ({
  routerProps: { location },
  getSavedScrollPosition,
}) => {
  // If navigating to an in-page anchor, let our custom handler manage the scroll
  if (location && location.hash) {
    return false;
  }

  const currentPosition = getSavedScrollPosition(location);
  setTimeout(() => {
    window.scrollTo(...(currentPosition || [0, 0]));
  }, 0);
  return false;
};

exports.onRouteUpdate = ({ location }) => {
  if (location && location.hash) {
    scrollToAnchorIfPresent(location.hash);
  }
};

exports.onClientEntry = () => {
  if (typeof window !== "undefined") {
    window.addEventListener("hashchange", () => {
      scrollToAnchorIfPresent(window.location.hash);
    });
  }
};
